<div class="main-content">
  <div class="container-fluid">

    <!-- Service tabs -->
    <div class="service-tabs">
      <button *ngFor="let svc of SERVICE_TYPES"
              (click)="setService(svc)"
              [class.active]="activeService === svc"
              class="service-tab">
        {{ SERVICE_LABELS[svc] }}
      </button>
    </div>

    <!-- Controls row -->
    <div class="admin-controls">
      <div class="filter-pills">
        <button (click)="changeFilter(ProjectStatusFilter.all)"
                [class.active]="filter == ProjectStatusFilter.all"
                class="pill">All</button>
        <button (click)="changeFilter(ProjectStatusFilter.draft)"
                [class.active]="filter == ProjectStatusFilter.draft"
                class="pill pill--default">Draft</button>
        <button (click)="changeFilter(ProjectStatusFilter.pending)"
                [class.active]="filter == ProjectStatusFilter.pending"
                class="pill pill--warning">Pending</button>
        <button (click)="changeFilter(ProjectStatusFilter.eligible)"
                [class.active]="filter == ProjectStatusFilter.eligible"
                class="pill pill--success">Eligible</button>
        <button (click)="changeFilter(ProjectStatusFilter.not_eligible)"
                [class.active]="filter == ProjectStatusFilter.not_eligible"
                class="pill pill--danger">Not Eligible</button>
        <button (click)="changeFilter(ProjectStatusFilter.proactive)"
                [class.active]="filter == ProjectStatusFilter.proactive"
                class="pill pill--info">Proactive</button>
      </div>
      <div class="controls-right">
        <div class="search-wrap">
          <i class="fa fa-search search-icon"></i>
          <input class="form-control search-input"
                 placeholder="Search by name, acronym, organisation…"
                 [(ngModel)]="search"
                 (ngModelChange)="changeSort(sortBy)">
        </div>
        <button *ngIf="exportAuthorized()" class="btn btn-default export-btn" (click)="exportCSV()">
          <i class="fa fa-download"></i> Export CSV
        </button>
      </div>
    </div>

    <!-- Sort row -->
    <div class="sort-row">
      <span class="sort-label">Sort:</span>
      <button (click)="changeSort('name')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'name'">
        Name
        <i class="fa" [ngClass]="sortBy === 'name' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('surname')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'surname'">
        Surname
        <i class="fa" [ngClass]="sortBy === 'surname' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('projectName')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'projectName'">
        Project Name
        <i class="fa" [ngClass]="sortBy === 'projectName' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
      <button (click)="changeSort('acronym')" class="btn btn-xs btn-sort" [class.active]="sortBy === 'acronym'">
        Acronym
        <i class="fa" [ngClass]="sortBy === 'acronym' ? (sortDirection === 1 ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
      </button>
    </div>

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading && getProjects().length === 0" class="empty-state">
      <i class="fa fa-inbox fa-2x"></i>
      <p>No applications match the current filter.</p>
    </div>

    <!-- Project list -->
    <div *ngIf="!loading" class="epe-list">
      <div *ngFor="let project of getProjects()" class="epe-item">

        <!-- Summary row -->
        <div class="epe-summary" (click)="expand(getAppId(project))">

          <div class="epe-id-col">
            <span class="user-name" *ngIf="project.name || project.surname">
              {{ project.name }} {{ project.surname }}
            </span>
            <span class="user-id" *ngIf="project.project_acronym">
              {{ project.project_acronym }}
            </span>
            <span class="user-id">User&nbsp;#{{ project.user_id || project.id }}</span>
            <span class="label epe-status-badge" [ngClass]="getStatusBadgeClass(project.status)">
              {{ getStatusLabel(project.status) }}
            </span>
          </div>

          <div class="epe-info-col">
            <div class="epe-topics" *ngIf="getTopicLabels(project).length > 0">
              <span *ngFor="let t of getTopicLabels(project).slice(0, 3)" class="topic-mini">{{ t }}</span>
              <span *ngIf="getTopicLabels(project).length > 3" class="topic-more">
                +{{ getTopicLabels(project).length - 3 }} more
              </span>
            </div>
            <div class="epe-submitted">
              <span class="epe-submitted-label">Submitted</span>
              {{ project.created_at | date:'d MMM yyyy' }}
            </div>
          </div>

          <div class="epe-right-col">
            <button class="btn btn-sm btn-action">
              <i class="fa" [ngClass]="selected === getAppId(project) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              {{ selected === getAppId(project) ? 'Close' : getBtnText(project.status) }}
            </button>
          </div>

        </div>

        <!-- Expanded detail -->
        <div *ngIf="selected === getAppId(project)" class="epe-detail">
          <div class="row">
            <!-- Left: project data -->
            <div class="col-md-8">

              <!-- User Profile -->
              <div class="detail-section" *ngIf="project.user_info">
                <h5 class="detail-section-title">User Profile</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Name</label><p>{{ project.user_info.name || '—' }} {{ project.user_info.surname || '' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Username</label><p>{{ project.user_info.username || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Email</label><p>{{ project.user_info.email || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Gender</label><p>{{ project.user_info.gender || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Organisation</label><p>{{ project.user_info.organisation || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Country</label><p>{{ project.user_info.country || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.user_info.organisation_type">
                    <div class="detail-field"><label>Organisation Type</label><p>{{ project.user_info.organisation_type }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.user_info.phone_number">
                    <div class="detail-field"><label>Phone</label><p>{{ project.user_info.phone_number }}</p></div>
                  </div>
                </div>
              </div>

              <!-- About Your Project -->
              <div class="detail-section">
                <h5 class="detail-section-title">About Your Project</h5>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Acronym</label><p>{{ project.form_data?.project_acronym || '—' }}</p></div>
                  </div>
                  <div class="col-sm-8">
                    <div class="detail-field"><label>Full Name</label><p>{{ project.form_data?.full_project_name || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.funding_type">
                    <div class="detail-field"><label>Funding Type</label><p>{{ project.form_data?.funding_type }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Funding Programme</label><p>{{ project.form_data?.funding_programme || '—' }}<span *ngIf="project.form_data?.other_funding_programme" class="text-muted"> — {{ project.form_data?.other_funding_programme }}</span></p></div>
                  </div>
                  <ng-container *ngIf="project.form_data?.national_programme_name || project.form_data?.national_programme_country">
                    <div class="col-sm-6">
                      <div class="detail-field"><label>National Programme</label><p>{{ project.form_data?.national_programme_name || '—' }}</p></div>
                    </div>
                    <div class="col-sm-6">
                      <div class="detail-field"><label>National Programme Country</label><p>{{ project.form_data?.national_programme_country || '—' }}</p></div>
                    </div>
                  </ng-container>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Grant Agreement Number</label><p>{{ project.form_data?.grant_agreement || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.coordinator_country">
                    <div class="detail-field"><label>Coordinator Country</label><p>{{ project.form_data?.coordinator_country }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Project Call / Topic ID</label><p>{{ project.form_data?.project_call_topic_id || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field">
                      <label>Project Website</label>
                      <p>
                        <a *ngIf="project.form_data?.project_website; else noWebsite"
                           [href]="project.form_data?.project_website" target="_blank" rel="noopener">
                          {{ project.form_data?.project_website }}
                        </a>
                        <ng-template #noWebsite>—</ng-template>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Project Officer Name</label><p>{{ project.form_data?.project_officer_name || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6" *ngIf="project.form_data?.project_officer_email">
                    <div class="detail-field"><label>Project Officer Email</label><p>{{ project.form_data?.project_officer_email }}</p></div>
                  </div>
                </div>
              </div>

              <!-- Topics -->
              <div class="detail-section">
                <h5 class="detail-section-title">Open Call Topics</h5>
                <div *ngIf="getTopicLabels(project).length > 0">
                  <span *ngFor="let t of getTopicLabels(project)" class="topic-badge-detail">{{ t }}</span>
                </div>
                <span *ngIf="getTopicLabels(project).length === 0" class="text-muted">—</span>
              </div>

              <!-- About the Support -->
              <div class="detail-section">
                <h5 class="detail-section-title">About the Support</h5>
                <div class="detail-field" *ngIf="project.form_data?.information_to_attain?.length > 0">
                  <label>Information / Support requested</label>
                  <ul class="list-unstyled" style="margin: 4px 0 0;">
                    <li *ngFor="let item of project.form_data?.information_to_attain" style="margin-bottom: 3px;">
                      <i class="fa fa-check" style="color:#27ae60; margin-right:5px;"></i>{{ item }}
                    </li>
                  </ul>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.project_short_description">
                  <label>Short Project Description</label>
                  <p class="tell-us-more">{{ project.form_data?.project_short_description }}</p>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.why_the_project_applying">
                  <label>Why applying?</label>
                  <p class="tell-us-more">{{ project.form_data?.why_the_project_applying }}</p>
                </div>
                <div class="detail-field" *ngIf="project.form_data?.other_support_specification">
                  <label>Other support specification</label>
                  <p class="tell-us-more">{{ project.form_data?.other_support_specification }}</p>
                </div>

                <ng-container *ngIf="project.application_type === 'service2'">
                  <div class="detail-field" *ngIf="project.form_data?.support_expectations">
                    <label>What do you expect from HSbooster.eu II proposal support?</label>
                    <p class="tell-us-more">{{ project.form_data?.support_expectations }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.one_pager_file_id">
                    <label>1-pager</label>
                    <p>
                      <a [href]="'/api/v1/applications/cv-download/' + project.form_data.one_pager_file_id"
                         target="_blank" rel="noopener" class="cv-link">
                        <i class="fa fa-file-pdf-o"></i> Download 1-pager
                      </a>
                    </p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.objectives_standardisation">
                    <label>Standardisation activities mentioned in the call text</label>
                    <p class="tell-us-more">{{ project.form_data?.objectives_standardisation }}</p>
                  </div>
                  <div class="row">
                    <div class="col-sm-6" *ngIf="project.form_data?.trl_start">
                      <div class="detail-field"><label>TRL starting point</label><p>{{ project.form_data?.trl_start }}</p></div>
                    </div>
                    <div class="col-sm-6" *ngIf="project.form_data?.trl_target">
                      <div class="detail-field"><label>Expected TRL after the project</label><p>{{ project.form_data?.trl_target }}</p></div>
                    </div>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.applicable_regulations">
                    <label>Applicable regulations</label>
                    <p class="tell-us-more">{{ project.form_data?.applicable_regulations }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.call_deadline">
                    <label>Call deadline</label>
                    <p>{{ project.form_data?.call_deadline | date:'d MMMM yyyy' }}</p>
                  </div>
                </ng-container>
              </div>

              <!-- Availability and Language (PSS) -->
              <div class="detail-section" *ngIf="project.application_type === 'service2' && (project.form_data?.support_start || project.form_data?.scheduling_constraints || project.form_data?.preferred_languages || project.form_data?.time_zone)">
                <h5 class="detail-section-title">Availability and Language Preference</h5>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Support start</label><p>{{ project.form_data?.support_start || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Scheduling constraints</label><p class="tell-us-more">{{ project.form_data?.scheduling_constraints || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Preferred language(s)</label><p>{{ project.form_data?.preferred_languages || '—' }}</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="detail-field"><label>Time zone</label><p>{{ project.form_data?.time_zone || '—' }}</p></div>
                  </div>
                </div>
              </div>

              <!-- Standards Knowledge -->
              <div class="detail-section" *ngIf="project.form_data?.know_standards">
                <h5 class="detail-section-title">Standards Knowledge</h5>
                <div class="detail-field">
                  <label>Already knows relevant standards?</label>
                  <p>{{ project.form_data?.know_standards === 'yes' ? 'Yes' : 'No' }}</p>
                  <p *ngIf="project.application_type === 'service2' && project.form_data?.know_standards === 'yes' && project.form_data?.standards_details" class="tell-us-more">{{ project.form_data?.standards_details }}</p>
                </div>
                <ng-container *ngIf="project.application_type === 'service2'">
                  <div class="detail-field" *ngIf="project.form_data?.nsb_contact">
                    <label>Contact with a National Standardisation Body</label>
                    <p>{{ project.form_data?.nsb_contact === 'yes' ? ('Yes — ' + (project.form_data?.nsb_contact_name || '—')) : 'No' }}</p>
                  </div>
                  <div class="detail-field" *ngIf="project.form_data?.known_standards_yn">
                    <label>Knows standards relevant to the future project</label>
                    <p>{{ project.form_data?.known_standards_yn === 'yes' ? ('Yes — ' + (project.form_data?.known_standards_titles || '—')) : 'No' }}</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="project.form_data?.know_standards === 'yes'">
                  <div *ngFor="let ref of project.form_data?.standard_reference; let i = index" class="group-card">
                    <div class="group-card-header">Standard #{{ i + 1 }}</div>
                    <div class="group-card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="detail-field"><label>SDO / NSB</label><p>{{ $any(ref).sdo || '—' }}<span *ngIf="$any(ref).other_options" class="text-muted"> — {{ $any(ref).other_options }}</span></p></div>
                        </div>
                        <div class="col-sm-3" *ngIf="$any(ref).tc_number">
                          <div class="detail-field"><label>TC/SC/WG No.</label><p>{{ $any(ref).tc_number }}</p></div>
                        </div>
                        <div class="col-sm-3" *ngIf="$any(ref).tc_title">
                          <div class="detail-field"><label>TC/SC/WG Title</label><p>{{ $any(ref).tc_title }}</p></div>
                        </div>
                        <div class="col-sm-12">
                          <div class="detail-field">
                            <label>Relationship</label>
                            <p>
                              <span *ngIf="$any(ref).is_contribute">Contribute</span>
                              <span *ngIf="$any(ref).is_contribute && $any(ref).is_use"> · </span>
                              <span *ngIf="$any(ref).is_use">Use / implement</span>
                              <span *ngIf="!$any(ref).is_contribute && !$any(ref).is_use" class="text-muted">—</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Consent -->
              <div class="detail-section">
                <h5 class="detail-section-title">Consent</h5>
                <div class="row">
                  <div class="col-sm-4" *ngIf="project.application_type !== 'service2'">
                    <div class="detail-field"><label>Publish project information on website</label><p>{{ project.form_data?.website_publication ? 'Yes' : 'No' }}</p></div>
                  </div>
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Data processing consent</label><p>{{ project.form_data?.data_consent ? 'Agreed' : '—' }}</p></div>
                  </div>
                  <div class="col-sm-4">
                    <div class="detail-field"><label>Accuracy declaration</label><p>{{ project.form_data?.accuracy_declaration ? 'Agreed' : '—' }}</p></div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Eligibility panel -->
            <div class="col-md-4">
              <project-sopcard-small [project]="project"></project-sopcard-small>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
